namespace $ {
	
	export var $mol_dom = $mol_dom_context
	
}
